
import draggable from 'vuedraggable'
// import { common } from '@/api'

export default {
  name: 'ImageUpload',
  components: {
    draggable,
  },
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    max: {
      type: Number,
      default: 16,
    },
    disablePreview: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: '150px',
    },
    height: {
      type: String,
      default: '150px',
    },
  },
  data() {
    return {
      // 组件内部数据.
      imageList: [],
      loading: false,
      uploadPercent: 0,
      imageDialogVisible: false,
      // 预览大图的url, 每次点击都会更新
      imageUrl: '',
    }
  },
  computed: {
    fulled() {
      return 0
    },
  },
  watch: {
    list() {
      this.imageList = JSON.parse(JSON.stringify(this.list))
    },
  },
  mounted(){
    this.updateList()
  },
  methods: {
    handleUpload(file, fileList) {
      this.fileList = []

      if (file.status === 'ready') {
        this.loading = true
        const interval = setInterval(() => {
          if (this.uploadPercent >= 99) {
            clearInterval(interval)
            return
          }
          this.uploadPercent += 1 // 进度条进度
        }, 100)
      }

      const formData = new FormData()
      fileList.forEach((file) => {
        formData.append('file', file.raw)
      })
      formData.append('type', 1)
      this.$axios
        .post(`/uk-api/user_base/imagesUpload`,formData)
        .then((response) => {
          if (response.result.code === 200) {
            this.imageList.push({
              url: response.result.data,
              uid: file.uid,
            })

            this.updateList()
            return
          }
          this.$message({
            message: response.result.message,
            type: 'warning',
          })
        })
        .catch((error) => {
          console.log(error, 'component upload image error')
          this.$message.error(error.response.data.msg)
        })
        .finally(() => {
          this.loading = false
          // 进度条恢复到初始状态
          this.uploadPercent = 0
        })
    },
    handleRemove(index) {
      this.imageList.splice(index, 1)
      this.updateList()
    },
    handlePictureCardPreview(file) {
      this.imageUrl = file.url
      this.imageDialogVisible = true
    },
    // 每次更新imageList后手动更新父组件的数据, 不能用watch自动更新, 因为同时要watch prop值更新iamgeList, 同时watch会死循环.
    // 直接把prop数据绑定到dragable 和 el-upload的话vue和eslint会报错, 也可能造成调试困难
    updateList() {
      this.$emit('update:list', JSON.parse(JSON.stringify(this.imageList)))
    },
    end() {
      this.updateList()
    },
  },
}
